import _enUS from './enUS/translation.json';
import _ptBR from './ptBR/translation.json';


export const ln_enUS = _enUS;
export const ln_ptBR = _ptBR;